import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private uri = 'plan/api/notification';

    
    constructor(private httpClient: HttpClient) { }

    employees(companyName: string, deptName: string) {
        let params = new HttpParams().set('companyName', companyName).set('deptName', deptName);
        return this.httpClient.get(this.uri + '/employees', { params: params });
    }

    employeeDepts() {
        return this.httpClient.get(this.uri + '/employeeDepts');
    }

    newgroup(requestParam: any) {
        return this.httpClient.post(this.uri + '/newgroup', requestParam);
    }

    removegroup(requestParam: any) {
        return this.httpClient.post(this.uri + '/removegroup', requestParam);
    }

    allgroup() {
        return this.httpClient.get(this.uri + '/allgroup');
    }

    allgrouphasson() {
        return this.httpClient.get(this.uri + '/allgrouphasson');
    }

    groupmembers(requestParam: any) {
        return this.httpClient.post(this.uri + '/groupmembers', requestParam);
    }

    savegroupmembers(requestParam: any) {
        return this.httpClient.post(this.uri + '/savegroupmembers', requestParam);
    }


    newtemplate(requestParam: any) {
        return this.httpClient.post(this.uri + '/newtemplate', requestParam);
    }

    removetemplate(requestParam: any) {
        return this.httpClient.post(this.uri + '/removetemplate', requestParam);
    }

    updatetemplate(requestParam: any) {
        return this.httpClient.post(this.uri + '/updatetemplate', requestParam);
    }

    alltemplate() {
        return this.httpClient.get(this.uri + '/alltemplate');
    }

    notifybyemergency(requestParam: any) {
        return this.httpClient.post(this.uri + '/notifybyemergency', requestParam);
    }

    notifybymessage(requestParam: any) {
        return this.httpClient.post(this.uri + '/notifybymessage', requestParam);
    }

    history(requestParam: any) {
        return this.httpClient.post(this.uri + '/history', requestParam);
    }

    historyattachments(id: any) {
        return this.httpClient.get(this.uri + '/historyattachments', { params: { id } });
    }

}
